<ng-container *ngIf="showData && !isShowComparePage">
  <div [ngSwitch]="currentpage">
    <div *ngSwitchCase="0">
      <ng-container *ngIf="currentpage === 0 && formData?.filledByInfos.length>0">
        <div class="container-fluid">
          <div class="row titlename">
            <div class="col-md-12 head-top">
              <h1 class="bannerTitle mb-0">Background  <span></span></h1>
            </div>
          </div>
        </div>
        <div class="page-wrapper ">
          <div class="container-fluid">
            <div class="row mt-2">
              <div class="col-md-12 mb-3 mt-2">
                <!-- <div class="note">Please fill out the below information as a family shares it with you over the phone or via email. <br> Note: We are not telling families we are calculating their competing scholarship options. This tool is to help inform your conversation.</div> -->
             
             <!-- jgkjgkjgkj -->
             </div>
              <div class="col-md-12 mb-2 mt-1">
                <!-- <form id="form"> -->
                <div class="row">
                  <div class="col-xl-4 col-md-6  mb-3" *ngFor="let info of calculatedFilledbyinfoArray"> 
                    <div class="form-group row">
                      <div class="col-sm-12 fm-row">
                        <ng-container>
                          <lib-virtue-form  [answerMap]="answerMap" [inputWidget]="info" (validated)="formValid($event)"
                            (errorInput)="errorInput($event)" (addInput)="changeinputinformfilled($event)"
                            (removeInput)="removeinput($event)" [widgetno]="0" [configId]="getConfigId(info)"
                            [showError]="showError" [disabled]="getDisabled(info)" [value]="getValue(info)"
                            [altValue]="getaltValue(info)">
                          </lib-virtue-form>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                <div class="col-md-12">
                  <div class="bg-light p-4 note-bg mb-4" *ngIf="isInternatinalStudent == true">
                    <p class="background-note mt-2" *ngIf="extraData?.backgroundForm_FN">
                      {{extraData?.backgroundForm_FN}}
                    <!-- Notes & Disclaimer: The merit grants will not be accurate for International students or federally independent students.</p> -->
                  </div>
                </div>
                </div>
              </div>
             
          
              <!-- </form> -->
            </div>
          </div>
        </div>
      </ng-container>
      <!-- </div> -->
    </div>
    <div *ngSwitchCase="7">
      <div class="container-fluid">
        <div class="row titlename">
          <div class="col-md-12 head-top">
            <h1 class="bannerTitle mb-0" *ngIf="basePath === 'top5'"> Selections <span></span>  </h1>
          </div>
        </div>
      </div>
      <app-interest-top5-college-selection *ngIf="isInternatinalStudent == false" [answerMap]="answerMap"
        (optionData)="changeOptionDaat($event)"></app-interest-top5-college-selection>
     
        <app-international-top5-selection *ngIf="isInternatinalStudent == true" [answerMap]="answerMap"
        (optionData)="changeOptionDaat($event)"></app-international-top5-selection>
    </div>

    <div *ngSwitchCase="8">
      <div class="mx-0 titlename">
        <div class="col-md-12 head-top">
          <h1 class="bannerTitle mb-0">
            Comparisons <span></span>
          </h1>

        </div>
      </div>
      <div>
        <app-result [answerMap]="answerMap" [mergedUniversityList]="opdata"></app-result>
      </div>
    </div>
    <div *ngSwitchDefault>
      <ng-container *ngIf="currentpage > 0">
        <div class="col-md-12 ">
          <div class="col-md-12">
            <h1 class="bannerTitle mb-0" *ngIf="pageData?.pageTitle">
              {{ pageData?.pageTitle }}
            </h1>
          </div>
        </div>
        <ng-container *ngIf="pageData?.inputWidgets">
          <div *ngFor="let widget of pageData.inputWidgets">
            <app-widget [inputwidget]="widget" (isInternational)="changeUSCitizen($event)" (inputwidgetoutput)="changeWidgetInput($event)"
              (removewidgetInput)="removeinput($event)" (validated)="formValid($event)" [showError]="showError"
              [answerMap]="answerMap">
            </app-widget>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div class="align-page-bottom fixed-bottom pb-5" *ngIf="currentpage >= 1  && currentpage < 7">
    <div class="text-center border-top pt-3">
      <button class="page-btn" (click)="goBack()" *ngIf="currentpage > 1 && currentpage < 7">
        Previous
      </button>
      <button class="page-btn" [disabled]="!isValid"  (click)="gotoStep()"
        [ngClass]="!isValid ? 'cursor-not-allowed' : ''">
        Next
      </button>
    </div>
  </div>
</ng-container>


<ng-container *ngIf="isShowComparePage">
  <ng-container [ngSwitch]="currentpage">

    <div *ngSwitchCase="7">
      <div class="container-fluid">
        <div class="row titlename">
          <div class="col-md-12 head-top">
            <h1 class="bannerTitle mb-0" *ngIf="basePath === 'top5'">
              Selections  <span></span>
            </h1>
          </div>

        </div>
      </div>
      <app-comparecolleges *ngIf="isInternatinalStudent == false"  [answerMap]="answerMap" (optionData)="changeOptionDaat($event)"></app-comparecolleges>
      <app-international-top5-compare *ngIf="isInternatinalStudent == true"  [answerMap]="answerMap" (optionData)="changeOptionDaat($event)"></app-international-top5-compare>
    </div>
    <div *ngSwitchCase="8">
      <div class="mx-3 titlename">
        <div class="col-md-12 head-top">
          <h1 class="bannerTitle mb-0" *ngIf="basePath === 'top5'">
            Comparisons  <span></span>
          </h1>

        </div>
      </div>
      <div>
        <app-result [answerMap]="answerMap" [mergedUniversityList]="opdata"></app-result>
      </div>
    </div>
  </ng-container>
</ng-container>

<!-- <a  [href]="efcURL()" target="_blank">EFC URL</a> -->


